<template>
  <div class="tab-content overflow-auto">
    <!--BEGIN: invoice list-->

    <!-- Show elements and global search-->
    <div class="paginator-container">
      <div class="flex items">
        <div class="mr-5 my-2 flex justify-between">
          <span class="flex-row text-sm ml-2 font-bold mr-2 mt-1">Mostra </span>
          <select
            v-model="pagination.forPage"
            class="form-select w-16 h-6 px-3 pt-0 pb-1 border-transparent bg-theme-2 focus:ring-1 focus:ring-theme-44 focus:outline-none placeholder-theme-44"
            @change="(event) => changeNumPages(event)"
          >
            <option
              v-for="show in forPageOption"
              :key="show"
              :value="show"
              class="form-select"
            >
              {{ show }}
            </option>
          </select>
          <span class="text-sm font-bold ml-2 mt-1"> elementi</span>
        </div>

        <input
          v-model="ricerca"
          type="text"
          placeholder="Cerca"
          class="pl-3 pr-10 py-1 border-2 border-gray-200 rounded-full focus:outline-none focus:ring-1 focus:ring-gray-500 placeholder-gray-500"
        />
      </div>
      <Paginator
        :for-page-option="pagination.forPage"
        :total-records="totalRecords"
        @changePagination="
          (event) => $h.debounce(() => changePagination(event))
        "
      />
    </div>
    <!-- BEGIN: Data List -->

    <div
      id="invoices"
      class="tab-pane active"
      role="tabpanel"
      aria-labelledby="invoices_mobile-tab"
    >
      <div
        class="table-container scrollbar-thin scrollbar-thumb-theme-44 scrollbar-track-theme-2 overflow-scroll"
      >
        <table
          class="w-full shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <thead class="h-10 t-header">
            <tr>
              <th
                v-for="(item, itemKey) in tableConfig_invoices"
                :key="itemKey"
                :name="item.title"
                class="px-6 py-3 text-white border-b-2 border-theme-41 whitespace-nowrap text-center font-semibold bg-theme-40 uppercase"
              >
                {{
                  item.key === 'price'
                    ? iva === false
                      ? item.title + ' senza IVA'
                      : item.title + ' con IVA'
                    : item.title
                }}
              </th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr class="">
              <td
                v-for="(elem, index) in tableConfig_invoices"
                :key="index"
                class="text-center pr-3 pb-3"
              >
                <div
                  v-if="elem.title === 'Data invio'"
                  class="flex-col text-left"
                >
                  <div class="flex items-baseline">
                    <span class="mr-2 font-bold">Da: </span
                    ><input
                      v-model="startDate"
                      class="custom-input"
                      type="date"
                      lang="it-IT"
                      @change="filterHandler(elem)"
                    />
                  </div>
                  <div class="flex items-baseline">
                    <span class="mr-4 font-bold">A: </span
                    ><input
                      v-model="endDate"
                      class="custom-input"
                      type="date"
                      lang="it-IT"
                      @change="filterHandler(elem)"
                    />
                  </div>
                </div>
                <div
                  v-else-if="elem.title === 'Data Documento'"
                  class="flex-col text-left"
                >
                  <div class="flex items-baseline">
                    <span class="mr-2 font-bold">Da: </span
                    ><input
                      v-model="startDateDocument"
                      class="custom-input"
                      type="date"
                      @change="filterHandler(elem)"
                    />
                  </div>
                  <div class="flex items-baseline">
                    <span class="mr-4 font-bold">A: </span
                    ><input
                      v-model="endDateDocument"
                      class="custom-input"
                      type="date"
                      @change="filterHandler(elem)"
                    />
                  </div>
                </div>
                <select
                  v-else-if="elem.type === 'select'"
                  v-model="elem.value"
                  class="w-full border rounded-md h-7 text-gray-500 mt-2"
                  @change="filterHandler(elem)"
                >
                  <option selected value=""></option>
                  <option
                    v-for="(item, i) in elem.option"
                    :key="i"
                    :value="item.id ? item.id : item"
                  >
                    {{ item.name ? item.name : item }}
                  </option>
                </select>

                <div
                  v-else-if="elem.key === 'refresh'"
                  class="flex-col text-center cursor-pointer"
                  @click="refreshStates()"
                >
                  <div class="flex items-center" style="margin-top: 8%">
                    <span class="mr-2 font-bold">
                      <i class="fas fa-sync"></i>
                    </span>
                    <span>Aggiorna Stati</span>
                  </div>
                </div>

                <input
                  v-else
                  v-model="elem.value"
                  :type="elem.type"
                  :style="elem.style"
                  min="0"
                  :name="elem.title"
                  class="form-control h-7 mt-2 text-left border-theme-45 px-0"
                  :class="{
                    invisible: elem.type === 'none',
                    'p-0': elem.type === 'date'
                  }"
                  :placeholder="
                    elem.key === 'price'
                      ? iva === false
                        ? elem.title + ' senza IVA'
                        : elem.title + ' con IVA'
                      : elem.title
                  "
                  @change="filterHandler(elem)"
                />
              </td>
            </tr>
            <tr
              v-for="(n, index) in invoices"
              :key="index"
              class="h-12 text-xs font-normal hover:bg-theme-44 cursor-pointer"
              :class="{ 'bg-theme-2': index % 2 === 0 }"
            >
              <Cell
                class="text-center border-r border-theme-45"
                :elementi="
                  n.data_invio ? $FormatDateMin(n.data_invio) : 'Non emessa'
                "
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              />
              <Cell
                class="text-center border-r border-theme-45"
                :elementi="$FormatDateMin(n.data_documento)"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              />
              <td
                class="text-center border-r border-theme-45 text-sm"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              >
                <b>
                  {{
                    n.clinic_sectional &&
                    n.clinic_sectional.prefix &&
                    n.clinic_sectional.bill_type_id === 4
                      ? n.clinic_sectional.prefix
                      : ''
                  }}
                  {{ n.n_bill }}
                </b>
              </td>
              <!-- <Cell
                :elementi="
                  n.customer
                    ? (n.customer.ragione_sociale
                        ? n.customer.ragione_sociale
                        : '') +
                      ' ' +
                      (n.customer.first_name ? n.customer.first_name : '') +
                      ' ' +
                      (n.customer.last_name ? n.customer.last_name : '')
                    : ''
                "
                class="text-center border-r border-theme-45 px-2"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              /> -->
              <td
                class="text-center border-r border-theme-45 text-sm whitespace-nowrap pr-3"
              >
                <div class="flex items-center gap-2 uppercase">
                  <div
                    v-if="n.customer"
                    class="tooltipbutton"
                    @click="handleGoToCustomer(n.customer)"
                  >
                    <ChevronsRightIcon class="orange-round" />
                    <span class="tooltipbuttontext">Apri Anagrafica</span>
                  </div>
                  {{
                    n.customer
                      ? (n.customer.ragione_sociale
                          ? n.customer.ragione_sociale
                          : '') +
                        ' ' +
                        (n.customer.first_name ? n.customer.first_name : '') +
                        ' ' +
                        (n.customer.last_name ? n.customer.last_name : '')
                      : ''
                  }}
                </div>
              </td>
              <Cell
                :elementi="n.bill_type ? n.bill_type.description : ''"
                class="text-center border-r border-theme-45"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              />
              <Cell
                :elementi="
                  n.total !== null
                    ? iva
                      ? Math.round((n.total + Number.EPSILON) * 100) / 100 + '€'
                      : Math.round((n.total / ivaPerc + Number.EPSILON) * 100) /
                          100 +
                        '€'
                    : ''
                  // ? Math.round((n.total + Number.EPSILON) * 100) / 100 + '€'
                  // : ''
                "
                class="text-center border-r border-theme-45"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              />
              <td
                class="text-center border-r border-theme-45 text-sm px-3 relative"
                @dblclick="handleDblClick_invoice()"
                @click="handleStatus(n.notifications, n)"
              >
                {{ n.status_doc }}
                <i
                  v-if="
                    n.notifications &&
                    n.status_doc &&
                    ![
                      'Inviata',
                      'Consegnata',
                      'Non consegnata',
                      'Consegnata cassetto fiscale',
                      'Cartacea'
                    ].includes(n.status_doc)
                  "
                  class="fas fa-info-circle absolute right-3 top-2 text-theme-41 cursor-pointer z-50"
                ></i>
              </td>
              <Cell
                :elementi="getCustomerType(n)"
                class="text-center border-r border-theme-45 px-3"
                @dblclick="handleDblClick_invoice()"
                @click="$emit('showInvoice', n)"
              />
              <td class="text-center border-r border-theme-45 px-3">
                <div
                  class="flex flex-col items-center text-center justify-evenly"
                >
                  <template v-if="n.status_doc == 'bozza'">
                    <span class="mb-1">BOZZA</span></template
                  >
                  <template v-else>
                    <span v-if="n.payment_status == 'paid'">{{
                      n.payment_status == 'paid' ? 'PAGATO' : ''
                    }}</span>
                    <span v-else class="mb-1">IN CORSO</span>
                    <input
                      v-if="n.payment_status == 'waiting'"
                      :id="n.id"
                      type="checkbox"
                      class="form-check-switch"
                      @click="setPaymentStatus(n.id, n.payment_status)"
                    />
                  </template>
                </div>
              </td>
              <td class="text-xs">
                <div class="flex gap-1 items-center text-sm">
                  <a
                    class="tooltipbutton w-5 h-5 flex items-center justify-center hover:text-theme-41"
                    @click="handleSavePdfRev(n)"
                  >
                    <i class="fas fa-file-pdf" />
                    <span class="tooltipbuttontext">Visualizza PDF</span>
                  </a>
                  <a
                    class="tooltipbutton w-5 h-5 flex items-center justify-center hover:text-theme-41"
                    @click="getXmlBill(n.id)"
                  >
                    <i class="fas fa-code"></i>
                    <span class="tooltipbuttontext">Visualizza XML</span>
                  </a>
                  <a
                    v-if="
                      n.bill_type.code != 'TD05' &&
                      permissions &&
                      permissions?.fatturazione?.emit_billing?.enabled ===
                        true &&
                      ![
                        'Inviata',
                        'Consegnata',
                        'Non consegnata',
                        'Consegnata cassetto fiscale',
                        'Cartacea',
                        'bozza'
                      ].includes(n.status_doc)
                    "
                    class="tooltipbutton w-5 h-5 flex items-center justify-center hover:text-theme-41"
                    @click="emetti(n.id, n.emission_type)"
                  >
                    <i class="fas fa-cloud-upload-alt"></i>
                    <span class="tooltipbuttontext"
                      style="width: 80px; margin-left: 1.5rem"
                      >Emetti</span>
                  </a>

                  <a
                    v-show="
                      n.bill_type &&
                      n.bill_type.id &&
                      n.bill_type.id !== 4 &&
                      n.bill_type.id !== 5 &&
                      !n.nota_di_credito_id &&
                      n.status_doc !== 'bozza'
                    "
                    class="tooltipbutton w-5 h-5 flex items-center justify-center hover:text-theme-41"
                    @click="handleNotaCredito(n)"
                  >
                    <svg viewBox="0 0 28 32" class="fill-current h-4 w-4">
                      <path
                        d="M3.123 25.485c0.002-0.723 0.222-1.802 1.254-2.841 1.495-1.503 3.041-3.048 4.596-4.592 0.763-0.759 1.676-1.2 2.64-1.279 1.079-0.087 2.109 0.293 2.898 1.071 0.719 0.708 1.116 1.655 1.117 2.664 0.001 0.412-0.063 0.818-0.188 1.209 1.584-0.004 3.189-0.022 4.759-0.089 0.508-0.022 1.169-0.137 1.801-0.72v-16.654c-0.001-2.35-1.906-4.255-4.256-4.255h-13.487c-2.351 0-4.256 1.905-4.256 4.255v20.698c0 0.147 0.007 0.292 0.022 0.435 0.044 0.429 0.151 0.839 0.312 1.222 0.135 0.318 0.307 0.617 0.511 0.89 0.245 0.328 0.537 0.619 0.864 0.864 0.219 0.163 0.453 0.306 0.701 0.426s0.509 0.216 0.781 0.286c0.34 0.087 0.697 0.134 1.064 0.134h0.955c-0.288-0.287-0.579-0.58-0.867-0.878-1.014-1.052-1.224-2.128-1.222-2.846zM10.999 7.246c0-0.301 0.244-0.544 0.544-0.544h8.638c0.301 0 0.544 0.244 0.544 0.544v0c0 0.301-0.244 0.544-0.544 0.544h-8.638c-0.301 0-0.544-0.244-0.544-0.544v0zM11.544 9.56h8.638c0.301 0 0.544 0.244 0.544 0.544s-0.244 0.544-0.544 0.544h-8.638c-0.301 0-0.544-0.244-0.544-0.544s0.244-0.544 0.544-0.544zM11.544 12.418h8.638c0.301 0 0.544 0.244 0.544 0.544s-0.244 0.544-0.544 0.544h-8.638c-0.301 0-0.544-0.244-0.544-0.544s0.244-0.544 0.544-0.544zM2.36 11.127c-0.191 0-0.349-0.063-0.476-0.191s-0.191-0.281-0.191-0.462 0.063-0.336 0.191-0.462c0.127-0.127 0.286-0.191 0.476-0.191h0.48c-0.004-0.161-0.008-0.313-0.011-0.456-0.003-0.128 0.001-0.258 0.011-0.388h-0.48c-0.191 0-0.349-0.063-0.476-0.191s-0.191-0.281-0.191-0.462c0-0.191 0.063-0.347 0.191-0.469s0.286-0.184 0.476-0.184h0.658c0.143-0.599 0.359-1.118 0.647-1.558 0.354-0.539 0.8-0.947 1.34-1.224s1.14-0.415 1.802-0.415c0.381 0 0.766 0.054 1.156 0.163s0.739 0.281 1.047 0.517c0.172 0.118 0.286 0.259 0.34 0.421s0.066 0.329 0.034 0.497-0.1 0.311-0.204 0.429c-0.104 0.118-0.238 0.188-0.401 0.211s-0.345-0.021-0.544-0.129c-0.172-0.118-0.372-0.206-0.599-0.265s-0.454-0.089-0.68-0.089c-0.308 0-0.587 0.061-0.837 0.184s-0.462 0.317-0.64 0.585c-0.123 0.186-0.227 0.41-0.313 0.673h1.326c0.191 0 0.347 0.064 0.469 0.191s0.184 0.281 0.184 0.462-0.061 0.325-0.184 0.456c-0.122 0.132-0.279 0.197-0.469 0.197h-1.56c-0.003 0.116-0.004 0.239-0.004 0.367 0 0.167 0.002 0.326 0.006 0.476h1.558c0.191 0 0.347 0.064 0.469 0.191s0.184 0.281 0.184 0.462-0.061 0.336-0.184 0.462c-0.122 0.127-0.279 0.191-0.469 0.191h-1.331c0.086 0.269 0.192 0.498 0.317 0.687 0.177 0.267 0.39 0.462 0.64 0.585s0.528 0.184 0.837 0.184c0.236 0 0.458-0.029 0.667-0.089s0.417-0.147 0.626-0.265c0.199-0.1 0.381-0.138 0.544-0.116s0.297 0.093 0.401 0.211c0.104 0.118 0.17 0.254 0.197 0.408s0.015 0.311-0.034 0.469c-0.050 0.159-0.157 0.302-0.319 0.429-0.299 0.236-0.646 0.413-1.040 0.53s-0.791 0.177-1.19 0.177c-0.662 0-1.263-0.138-1.802-0.415s-0.986-0.687-1.34-1.231c-0.29-0.445-0.506-0.967-0.65-1.564h-0.656z"
                      ></path>
                      <path
                        d="M10.795 23.834c0.329 0.059 0.48 0.11 0.63 0.109 2.957-0.022 5.917 0.027 8.869-0.1 2.157-0.093 3.67-1.314 4.604-3.247 0.109-0.224 0.181-0.467 0.288-0.691 0.389-0.808 1.134-1.096 1.993-0.78 0.744 0.274 1.145 1.020 0.909 1.823-0.705 2.405-2.244 4.115-4.466 5.233-1.241 0.624-2.564 0.904-3.949 0.905-2.64 0.002-5.279 0-7.919 0h-0.735c-0.031 0.050-0.062 0.1-0.093 0.151 0.374 0.37 0.748 0.739 1.121 1.11 0.291 0.288 0.588 0.571 0.868 0.869 0.646 0.689 0.661 1.729 0.044 2.338-0.604 0.596-1.601 0.609-2.283-0.038-1.006-0.956-1.972-1.953-2.954-2.933-0.596-0.595-1.199-1.182-1.783-1.788-0.805-0.835-0.802-1.773 0.008-2.587 1.524-1.532 3.053-3.060 4.587-4.583 0.791-0.786 1.754-0.859 2.421-0.201 0.667 0.657 0.6 1.723-0.172 2.489-0.622 0.617-1.26 1.219-1.988 1.923z"
                      ></path>
                    </svg>
                    <span class="tooltipbuttontext">Nota di credito</span>
                  </a>
                  <a
                    v-if="
                      ((n.status_doc &&
                        n.status_doc !== 'Inviata' &&
                        n.status_doc !== 'Consegnata' &&
                        n.status_doc !== 'Cartacea' &&
                        n.status_doc !== 'Consegnata cassetto fiscale') ||
                        (n.filename === null && n.emitted_by === null)) &&
                      permissions &&
                      permissions?.fatturazione?.edit_billing?.enabled === true
                    "
                    class="tooltipbutton w-5 h-5 flex items-center justify-center hover:text-theme-41"
                    @click="$emit('editInvoice', n)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      class="fill-current"
                      style="width: 0.85rem; height: 0.85rem"
                    >
                      <path
                        d="M362.7 19.32C387.7-5.678 428.3-5.678 453.3 19.32L492.7 58.75C517.7 83.74 517.7 124.3 492.7 149.3L444.3 197.7L314.3 67.72L362.7 19.32zM421.7 220.3L188.5 453.4C178.1 463.8 165.2 471.5 151.1 475.6L30.77 511C22.35 513.5 13.24 511.2 7.03 504.1C.8198 498.8-1.502 489.7 .976 481.2L36.37 360.9C40.53 346.8 48.16 333.9 58.57 323.5L291.7 90.34L421.7 220.3z"
                      />
                    </svg>
                    <span
                      class="tooltipbuttontext"
                      style="width: 80px; margin-left: 1.5rem"
                      >Modifica</span
                    >
                  </a>
                  <a
                    v-if="
                      n.bill_type.code === 'TD05' || n.status_doc === 'bozza'
                    "
                    class="tooltipbutton hover:text-theme-41 w-5 h-5 flex items-center justify-center"
                    :class="[
                      n.state == 'ANNULLATO'
                        ? 'opacity-40 cursor-default pointer-events-none'
                        : 'cursor-pointer',
                      ''
                    ]"
                    @click="handleDeleteRecord(n)"
                  >
                    <i class="fas fa-times" />
                    <span class="tooltipbuttontext">Cancella</span>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ConfirmModal
          v-if="showModal"
          @remove="removeRow"
          @close="showModal = false"
        />

        <InvoiceStatusModal
          v-if="showStatusModal"
          :notifications="notifications"
          @close="showStatusModal = false"
        />
      </div>
    </div>
    <!-- END: Data List -->

    <!-- START: Button export -->

    <div class="flex justify-end pt-3">
      <button
        class="orange-btn flex items-center gap-3"
        @click="handleExportInvoiceModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          class="w-5 fill-current"
        >
          <path
            d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
          />
        </svg>
        Esporta
      </button>
    </div>
    <!-- END: Button export -->

    <!--END: invoice list-->
  </div>
</template>
<script>
const forPageOption = [5, 10, 20, 50]

import Paginator from '../paginator/Main.vue'
import { mapGetters, mapActions } from 'vuex'
// import THeader from '../cvit-table/THeader.vue'
import Cell from '../../components/cvit-table/Cell.vue'
import axios from '../../gateway/backend-api'
import Toastify from 'toastify-js'
import ConfirmModal from './ConfirmModal.vue'
import InvoiceStatusModal from '../modals/InvoiceStatusModal.vue'

export default {
  components: {
    Paginator,
    // THeader,
    Cell,
    ConfirmModal,
    InvoiceStatusModal
  },
  props: {
    type: [],
    customer: Object,
    active: {
      type: [Boolean],
      default: true
    }
  },
  emits: [
    'showInvoice',
    'handleSavePdfRev',
    'handleNotaDiCredito',
    'editInvoice',
    'openExportInvoice',
    'refreshTables'
  ],
  data() {
    return {
      showExportInvoiceModal: false,
      notifications: null,
      showStatusModal: false,
      showModal: false,

      totalRecords: '',
      forPageOption,
      pagination: {
        page: 1,
        forPage: forPageOption[0]
      },

      filterActive: false,
      ricerca: '',
      startDate: null,
      endDate: null,
      startDateDocument: null,
      endDateDocument: null,
      active_filters: {},

      invoices: [],
      tableConfig_invoices: [
        {
          key: 'sendingDate',
          title: 'Data invio',
          type: 'none',
          style: 'display: none'
        },
        {
          key: 'document_date',
          title: 'Data documento',
          type: 'none',
          style: 'display: none'
        },
        {
          key: 'n_bill',
          title: 'Numero',
          type: 'text'
        },
        {
          key: 'customer',
          title: 'Cliente',
          type: 'text'
        },
        {
          key: 'bill_type_id',
          title: 'Tipo documento',
          type: 'select',
          option: []
        },
        {
          key: 'price',
          title: 'Totale',
          type: 'text'
        },
        {
          key: 'status_doc',
          title: 'Stato fatturazione',
          type: 'select',
          option: []
        },
        {
          key: 'customer',
          title: 'Tipo cliente',
          type: 'none'
        },
        {
          key: 'payment_status',
          title: 'Stato pagamento',
          type: 'select',
          option: [
            { name: 'Pagato', value: 'paid' },
            { name: 'In corso', value: 'waiting' }
          ]
        },
        {
          key: 'refresh',
          title: 'Azioni rapide',
          type: 'none'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      getCustomersDetails: 'anagraficaClienti/getCustomersDetails',
      getComparisonCustomer: 'anagraficaClienti/getComparisonCustomer',
      invoiceTypesClinic: 'reusableData/getInvoiceTypesClinic',
      invoiceTypes: 'reusableData/getInvoiceTypes',
      invoiceStatus: 'reusableData/getInvoiceStatus',
      iva: 'reusableData/getShowIva',
      permissions: 'reusableData/getPermissions',
      ivaPerc: 'reusableData/getRegimeFiscaleIvaPerc'
    })
  },
  mounted() {
    if (this.active) {
      this.getBills()
    }
    // this.getInvoiceTypesClinic() // TODO andrebbe valorizzata ed utilizzata la tabella
    this.getInvoiceTypes()
    this.getInvoiceStatus()
  },
  methods: {
    ...mapActions({
      getCustomerAction: 'anagraficaClienti/getCustomerAction',
      getSingleCustomerAction: 'anagraficaClienti/getSingleCustomerAction'
    }),
    handleGoToCustomer(owner) {
      this.$store.dispatch('commonComponents/showLoadingModalAction')
      axios
        .get('/' + localStorage.getItem('clinic') + '/customer/' + owner.id)
        .then((res) => {
          this.$store.dispatch('commonComponents/hideLoadingModalAction')
          this.$goToCustomer(res.data)
        })
    },
    getCustomerType(n) {
      if (n && n.customer) {
        return n.customer.type === 'PA'
          ? 'Pubblica Amministrazione'
          : n.customer.type
      }
      return undefined
    },
    tabAlreadyOpen: function () {
      Toastify({
        node: cash('#tab-already-open').clone().removeClass('hidden')[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    },
    handleStatus(notifications, doc) {
      this.notifications = null
      if (
        notifications &&
        doc.status_doc &&
        !['Inviata', 'Consegnata', 'Non consegnata'].includes(doc.status_doc)
      ) {
        if (Array.isArray(notifications[0]))
          this.notifications = notifications[0]
        else this.notifications = notifications

        this.showStatusModal = true
      } else {
        this.$emit('showInvoice', doc)
      }
    },
    handleDeleteRecord(doc) {
      this.$store.dispatch('commonComponents/openConfirmModal', {
        title: 'CONFERMA',
        subtitle: 'Sei sicuro di voler eliminare la fattura?',
        background: false,
        confirm_text: 'Conferma',
        decline_text: 'Annulla',
        confirm: () => {
          this.$store.dispatch('commonComponents/showLoadingModalAction')
          axios
            .post(
              '/' +
                localStorage.getItem('clinic') +
                '/bills/' +
                doc.id +
                '/delete',
              {}
            )
            .then(() => {
              this.$emit('refreshTables')
              this.$store.dispatch('commonComponents/hideLoadingModalAction')
            })
            .catch(() => {
              this.$store.dispatch('commonComponents/openNotificationModal', {
                message: 'Errore durante cancellazione fattura'
              })
              this.$store.dispatch('commonComponents/hideLoadingModalAction')
            })
        },
        decline: () => {}
      })
    },
    getInvoiceTypesClinic() {
      this.invoiceTypesClinic.map((elem) => {
        this.tableConfig_invoices[4].option.push({
          name: elem.description,
          id: elem.id
        })
      })
    },
    getInvoiceTypes() {
      this.invoiceTypes.map((elem) => {
        this.tableConfig_invoices[4].option.push({
          name: elem.description,
          id: elem.id
        })
      })
    },
    getInvoiceStatus() {
      this.invoiceStatus.map((elem) => {
        this.tableConfig_invoices[6].option.push(elem)
      })
    },
    getBills(refreshStates = false) {
      this.$store.dispatch('commonComponents/showLoadingModalAction')
      axios
        .post('/' + localStorage.getItem('clinic') + '/bills/index-bills', {
          customer_id: this.customer ? this.customer.id : null,
          active_filters: this.active_filters,
          sent_from: this.startDate,
          sent_to: this.endDate,
          document_date_from: this.startDateDocument,
          document_date_to: this.endDateDocument,
          iva: this.iva,
          page: this.pagination.page,
          per_page: this.pagination.forPage,
          refreshStates: refreshStates
        })
        .then((res) => {
          this.invoices = res.data.data
          this.totalRecords = res.data.total

          this.$store.dispatch('commonComponents/hideLoadingModalAction')
        })
        .catch(() => {
          this.$store.dispatch('commonComponents/hideLoadingModalAction')
        })
    },
    changePagination: function (value) {
      if (this.pagination.page != value.page) {
        this.pagination.page = value.page
        this.pagination.forPage = value.forPage
        this.getBills()
      }
    },
    changeNumPages: function (elem) {
      this.pagination.forPage = elem.target.value
      this.getBills()
    },
    getPdfBill(filename) {
      if (filename) {
        this.$store.dispatch('commonComponents/showLoadingModalAction')
        axios
          .get(
            '/' +
              localStorage.getItem('clinic') +
              '/bills/sent/filename/' +
              filename,
            {
              responseType: 'arraybuffer',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/pdf'
              }
            }
          )
          .then((response) => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Fattura_' + filename + '.pdf')
            document.body.appendChild(link)

            this.$store.dispatch('commonComponents/openPdfModal', {
              title: filename,
              link: url,
              background: false,
              print: () => {},
              download: () => {
                link.click()
              }
            })
          })
          .catch((error) => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')
            if (error.response.status == 501) {
              this.$store.dispatch('commonComponents/openNotificationModal', {
                message: 'Aggiornamento stato fattura.'
              })
            } else {
              this.$store.dispatch('commonComponents/openNotificationModal', {
                message: 'Ops, qualcosa è andato storto.'
              })
              this.getBills()
            }
          })
      }
    },
    getTipoFatturaLabel(id) {
      switch (id) {
        case 4:
          return 'Nota_Di_Credito'
        case 5:
          return 'Nota_Di_Debito'
        default:
          return 'Fattura'
      }
    },
    handleSavePdfRev(elem) {
      this.$store.dispatch('commonComponents/showLoadingModalAction')
      axios
        .post(
          '/' + localStorage.getItem('clinic') + '/bills/' + elem.id + '/pdf',
          {},
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/pdf'
            }
          }
        )
        .then((response) => {
          this.$store.dispatch('commonComponents/hideLoadingModalAction')
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            this.getTipoFatturaLabel(elem?.bill_type?.id) + elem.n_bill + '.pdf'
          )
          document.body.appendChild(link)
          this.$store.dispatch('commonComponents/openPdfModal', {
            title: elem.clinic_sectional
              ? elem.clinic_sectional.prefix +
                ' n.' +
                elem.clinic_sectional.n_doc
              : elem.n_bill,
            link: url,
            background: false,
            table_reference: 'active_bill',
            id_reference: elem.id,
            client: elem.customer,
            pdf_date: elem.data_documento,
            pdf_signed: elem.bill_type_id === 5 ? elem.signed : true,
            print: () => {},
            download: () => {
              link.click()
            },
            sign_done: () => {
              this.$emit('refreshTables')
            }
          })
        })
        .catch(() => {
          this.$store.dispatch('commonComponents/hideLoadingModalAction')
          this.$store.dispatch('commonComponents/openNotificationModal', {
            message: 'Errore, controllare indirizzo del cliente'
          })
        })
    },
    getXmlBill(id) {
      if (id) {
        this.$store.dispatch('commonComponents/showLoadingModalAction')
        axios
          .post('/' + localStorage.getItem('clinic') + '/bills/getXML', {
            bill_id: id
          })
          .then((response) => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')

            const url = window.URL.createObjectURL(
              new Blob([response.data.xml], { type: 'text/plain' })
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'xml_' + response.data.filename)
            document.body.appendChild(link)

            this.$store.dispatch('commonComponents/openPdfModal', {
              title: response.data.filename,
              link: null,
              background: false,
              print: () => {},
              download: () => {
                link.click()
              },
              xml: response.data.xml
            })
          })
          .catch(() => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')
            this.$store.dispatch('commonComponents/openNotificationModal', {
              message: 'Errore nella creazione XML'
            })
          })
      }
    },
    emetti(id, emission) {
      if (id) {
        if (emission) {
          if (emission === 'elettronica') {
            this.$store.dispatch('commonComponents/openConfirmModal', {
              title: 'CONFERMA',
              subtitle:
                'Sicuro di voler emettere la fattura in modalità elettronica?',
              background: false,
              confirm_text: 'Si',
              decline_text: 'No',
              confirm: () => {
                this.$store.dispatch('commonComponents/showLoadingModalAction')
                axios
                  .post(
                    '/' + localStorage.getItem('clinic') + '/bills/uploadXML',
                    {
                      bill_id: id
                    }
                  )
                  .then(() => {
                    this.$store.dispatch(
                      'commonComponents/hideLoadingModalAction'
                    )
                    this.getBills()
                  })
                  .catch((error) => {
                    this.$store.dispatch(
                      'commonComponents/hideLoadingModalAction'
                    )
                    if (error.response.status == 501) {
                      this.$store.dispatch(
                        'commonComponents/openNotificationModal',
                        {
                          message: 'Fattura già emessa con successo.'
                        }
                      )
                    } else {
                      this.$store.dispatch(
                        'commonComponents/openNotificationModal',
                        {
                          message: 'Ops, qualcosa è andato storto.'
                        }
                      )
                      this.getBills()
                    }
                  })
              },
              decline: () => {}
            })
          }
          if (emission === 'cartacea') {
            this.$store.dispatch('commonComponents/openConfirmModal', {
              title: 'CONFERMA',
              subtitle:
                'Sicuro di voler emettere la fattura in modalità cartacea?',
              background: false,
              confirm_text: 'Si',
              decline_text: 'No',
              confirm: () => {
                console.log('Cartacea')
                this.$store.dispatch('commonComponents/showLoadingModalAction')
                axios
                  .post(
                    '/' + localStorage.getItem('clinic') + '/bills/paperBill',
                    {
                      bill_id: id
                    }
                  )
                  .then(() => {
                    this.$store.dispatch(
                      'commonComponents/hideLoadingModalAction'
                    )
                    this.getBills()
                  })
                  .catch((error) => {
                    this.$store.dispatch(
                      'commonComponents/hideLoadingModalAction'
                    )
                    if (error.response.status == 501) {
                      this.$store.dispatch(
                        'commonComponents/openNotificationModal',
                        {
                          message: 'Fattura già emessa con successo.'
                        }
                      )
                    } else {
                      this.$store.dispatch(
                        'commonComponents/openNotificationModal',
                        {
                          message: 'Ops, qualcosa è andato storto.'
                        }
                      )
                      this.getBills()
                    }
                  })
              },
              decline: () => {}
            })
          }
        } else {
          this.$store.dispatch('commonComponents/openConfirmModal', {
            title: 'CONFERMA',
            subtitle: 'Si desidera emettere la fattura elettronica o cartacea?',
            background: false,
            confirm_text: 'Elettronica',
            decline_text: 'Cartacea',
            confirm: () => {
              this.$store.dispatch('commonComponents/showLoadingModalAction')
              axios
                .post(
                  '/' + localStorage.getItem('clinic') + '/bills/uploadXML',
                  {
                    bill_id: id
                  }
                )
                .then(() => {
                  this.$store.dispatch(
                    'commonComponents/hideLoadingModalAction'
                  )
                  this.getBills()
                })
                .catch((error) => {
                  this.$store.dispatch(
                    'commonComponents/hideLoadingModalAction'
                  )
                  if (error.response.status == 501) {
                    this.$store.dispatch(
                      'commonComponents/openNotificationModal',
                      {
                        message: 'Fattura già emessa con successo.'
                      }
                    )
                  } else {
                    this.$store.dispatch(
                      'commonComponents/openNotificationModal',
                      {
                        message: 'Ops, qualcosa è andato storto.'
                      }
                    )
                    this.getBills()
                  }
                })
            },
            decline: () => {
              console.log('Cartacea')
              this.$store.dispatch('commonComponents/showLoadingModalAction')
              axios
                .post(
                  '/' + localStorage.getItem('clinic') + '/bills/paperBill',
                  {
                    bill_id: id
                  }
                )
                .then(() => {
                  this.$store.dispatch(
                    'commonComponents/hideLoadingModalAction'
                  )
                  this.getBills()
                })
                .catch((error) => {
                  this.$store.dispatch(
                    'commonComponents/hideLoadingModalAction'
                  )
                  if (error.response.status == 501) {
                    this.$store.dispatch(
                      'commonComponents/openNotificationModal',
                      {
                        message: 'Fattura già emessa con successo.'
                      }
                    )
                  } else {
                    this.$store.dispatch(
                      'commonComponents/openNotificationModal',
                      {
                        message: 'Ops, qualcosa è andato storto.'
                      }
                    )
                    this.getBills()
                  }
                })
            }
          })
        }
      }
    },
    filterHandler(elem) {
      this.active_filters[elem.key] = elem.value

      this.checkIfFilterActive()

      if (this.filterActive) this.getBills()
    },
    checkIfFilterActive() {
      var count = 0
      Object.entries(this.active_filters).forEach((v) => {
        if (v) ++count
      })
      if (count > 0) this.filterActive = true
      else this.filterActive = false
    },
    handleNotaCredito: function (doc) {
      this.$emit('handleNotaDiCredito', doc)
    },
    setPaymentStatus(id, status) {
      axios
        .post(
          '/' +
            localStorage.getItem('clinic') +
            '/bills/' +
            id +
            '/set-payment-status',
          {
            status: status
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.invoices.forEach((el) => {
              if (el.id == id) el.payment_status = 'paid'
            })
            this.$emit('refreshTables')
          }
        })
        .catch(function () {})
    },
    refreshStates() {
      this.getBills(true)
    },
    handleExportInvoiceModal() {
      this.$emit('openExportInvoice')
    }
  }
}
</script>
